import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import Services from './pages/Services';
import About from './pages/About';
import Licenses from './pages/Licenses';
import SoloBeauty from './pages/SoloBeauty';
import FlashDelivery from './pages/FlashDelivery';
import FlashDeliveryHomepage from './pages/FlashDeliveryHomepage';
import FlashDeliveryMobile from './pages/FlashDeliveryMobile';
import Liveeasy from './pages/Liveeasy';
import PersonalWork from './pages/PersonalWork';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/licenses" element={<Licenses />} />
        <Route path="/projects/solo-beauty" element={<SoloBeauty />} />
        <Route path="/projects/flash-delivery" element={<FlashDelivery />} />
        <Route path="/projects/flash-delivery/homepage" element={<FlashDeliveryHomepage />} />
        <Route path="/projects/flash-delivery/mobile" element={<FlashDeliveryMobile />} />
        <Route path="/projects/liveeasy" element={<Liveeasy />} />
        <Route path="/projects/personal-work" element={<PersonalWork />} />
      </Routes>
    </Router>
  );
}

export default App;
